import { createContext, useEffect, useState } from "react";
import topApi from "../../components/api/ToPApi";
import { Bank, BanksResponse, Branch, BranchesResponse } from "../../models/interfaces";

type BranchContextProps = {
    branches: Branch[];
    banks: Bank[];
    loadBranches: () => Promise<void>;
    addBranch: (branch: Branch) => Promise<string>;
    updateBranch: (branch: Branch) => Promise<string>;
    deleteBranch: (id: number) => Promise<string>;
};

export const BranchContext = createContext({} as BranchContextProps);

export const BranchProvider = ({ children }: any) => {

    const [branches, setBranches] = useState<Branch[]>([]);
    const [banks, setBanks] = useState<Bank[]>([]);

    useEffect(() => {
        loadBranches();
    }, []);

    useEffect(() => {
        loadBanks();
    }, [])


    const loadBanks = async () => {

        if (banks.length == 0) {
            const resp = await topApi.get<BanksResponse>('/bank/getBanks');
            if (resp.status == 200) {
                setBanks([...resp.data.banks]);
            }
        }


    }

    const loadBranches = async () => {

        const resp = await topApi.get<BranchesResponse>('/branch/getBranchs');

        if (resp.status === 200) {
            setBranches(resp.data.branches);
        }
    };

    const addBranch = async (branch: Branch) => {
        try {

            const resp = await topApi.post('/branch/', { branch });

            setBranches([...branches, resp.data.branch]);

            return "success";

        } catch (e: any) {

            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";

        }
    };

    const updateBranch = async (branch: Branch) => {

        try {

            const resp = await topApi.put(`/branch/${branch.id}`, { branch });

            setBranches(
                branches.map(b =>
                    b.id === branch.id
                        ? resp.data.branch
                        : b
                )
            );

            return "success";

        } catch (e: any) {

            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";

        }
    };

    const deleteBranch = async (id: number) => {

        try {

            await topApi.delete(`/branch/${id}`);

            setBranches(prev =>
                prev.filter(b => b.id !== id)
            );

            return "success";

        } catch (e: any) {

            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";

        }
    };

    return (
        <BranchContext.Provider
            value={{
                banks,
                branches,
                loadBranches,
                addBranch,
                updateBranch,
                deleteBranch
            }}
        >
            {children}
        </BranchContext.Provider>
    );
};